import { h, Fragment } from "preact";
import { SimpleList } from "./SimpleList";

export function LabelMetadataElementList(props: {
    metadata: { [key: string]: string },
    style?: string,
    onChange: (value: string) => void,
    value: string,
    header: string,
    emptyListMessage: string,
    showOnlyDescriptions?: boolean,
    checkValidity?: (value: string) => boolean,
    validityError?: string
}) {
    return <SimpleList
        style={props.style}
        header={props.header}
        emptyListMessage={props.emptyListMessage}
        elements={Object.keys(props.metadata).filter(v => v.startsWith("element-"))}
        keyAccessor={(v) => v}
        onChange={props.onChange}
        value={props.value}
    >
        {item => <>
            {props.checkValidity?.(item) === false ? <span class="chip error icon tooltip tooltip-error" style="margin-right: 10px" data-tooltip={props.validityError ?? "Element jest nieprawidłowy"}>error</span> : null}
            <span class="chip secondary" style="margin-right: 10px;">{item.split("-").slice(1, 2)}</span>
            {!props.showOnlyDescriptions ? <span>{item.split("-").slice(2).join("-")}</span> : null}
            {props.showOnlyDescriptions
                ? props.metadata["description-" + item] ? <span>{props.metadata["description-" + item]}</span> : props.metadata[item]
                : props.metadata["description-" + item] ? <span style="color: #afafaf; font-size: 10px; margin-left: 5px">{props.metadata["description-" + item]}</span> : null
            }
        </>}
    </SimpleList>
}
